import React, { Component, useEffect, useState } from "react";
import AddNewTimeLog from "./AddNewTimeLog";
import Moment from "react-moment";
import AddEditNotes from "./AddEditNotes";
import CandidatePay from "./CandidatePay";
import {
  formatTotalHours,
  getFieldData,
  getMonthLastDay,
  getMonthName,
  getTotalDays,
  getTotalHours,
} from "../../Services/appService";
import { getAlert, getConfirmAlert } from "../../Services/appAlerts";
import {
  getCurrentUser,
  getLoggedUserDetails,
  loadUserDetails,
} from "../../app/store/auth";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteTimeSheetDoc,
  getProjectDateUpdateStatus,
  getTimeLogDuration,
  getTimeLogs,
  getTimeSheetDelStatus,
  loadTimeLogDuration,
  loadTimeLogs,
  updateProjectStartDate,
} from "../../app/store/timeLog";
import {
  getTimeLogInvoice,
  loadTimeLogInvoice,
} from "../../app/store/timeLogInvoice";
import useDocDownload from "../../app/hooks/useDocDownload";
import RateEncryptDecrypt from "../../Services/RateEncryptDecrypt";
import { getCandidateAppAllTasks } from "../../app/store/candidate";

const TIME_LOG_STYLES = {
  card: {
    borderRadius: "22px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "linear-gradient(180deg, #ffffff 0%, #fbfdff 100%)",
    boxShadow: "0 14px 34px rgba(15, 23, 42, 0.05)",
    overflow: "hidden",
  },
  cardHeader: {
    padding: "20px 22px 16px 22px",
    borderBottom: "1px solid rgba(226, 232, 240, 1)",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
  },
  titleRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "14px",
    flexWrap: "wrap",
  },
  titleWrap: {
    display: "inline-flex",
    alignItems: "center",
    gap: "12px",
    minWidth: 0,
  },
  titleIcon: {
    width: "38px",
    height: "38px",
    borderRadius: "12px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
    color: "#1d4ed8",
    fontSize: "16px",
    border: "1px solid rgba(191, 219, 254, 1)",
  },
  title: {
    fontSize: "18px",
    fontWeight: 800,
    color: "#0f172a",
    marginBottom: "4px",
  },
  subtitle: {
    fontSize: "13px",
    lineHeight: 1.6,
    color: "#64748b",
    margin: 0,
  },
  primaryButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(191, 219, 254, 1)",
    background: "#eff6ff",
    color: "#1d4ed8",
    padding: "8px 14px",
    fontSize: "12px",
    fontWeight: 700,
  },
  cardBody: {
    padding: "18px 22px 22px 22px",
  },
  statsRow: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "12px",
    marginBottom: "16px",
  },
  statCard: {
    borderRadius: "18px",
    padding: "14px 16px",
    background: "#ffffff",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    boxShadow: "0 10px 26px rgba(37, 99, 235, 0.06)",
  },
  statLabel: {
    fontSize: "11px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    marginBottom: "6px",
  },
  statValue: {
    fontSize: "22px",
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1.1,
  },
  statHint: {
    fontSize: "12px",
    lineHeight: 1.5,
    color: "#64748b",
    marginTop: "6px",
  },
  utilityRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
    marginBottom: "14px",
  },
  utilityPanel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "14px",
    padding: "14px 16px",
    borderRadius: "18px",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
    boxShadow: "0 10px 24px rgba(37, 99, 235, 0.06)",
    width: "100%",
    flexWrap: "wrap",
  },
  utilityPanelTop: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flex: 1,
    minWidth: 0,
  },
  utilityIcon: {
    width: "36px",
    height: "36px",
    borderRadius: "12px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
    color: "#1d4ed8",
    border: "1px solid rgba(191, 219, 254, 1)",
    flexShrink: 0,
  },
  utilityCopy: {
    minWidth: 0,
    flex: 1,
  },
  utilityLabel: {
    fontSize: "11px",
    fontWeight: 800,
    color: "#64748b",
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    margin: 0,
  },
  utilityValue: {
    fontSize: "16px",
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1.2,
    marginTop: "2px",
  },
  utilityActions: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexWrap: "wrap",
  },
  utilityEditor: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    flexWrap: "nowrap",
    marginLeft: "auto",
  },
  utilityInput: {
    minWidth: "160px",
    maxWidth: "240px",
  },
  utilityButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#334155",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: 700,
  },
  utilityPrimaryButton: {
    border: "1px solid rgba(191, 219, 254, 1)",
    background: "#eff6ff",
    color: "#1d4ed8",
  },
  utilityDangerButton: {
    color: "#475569",
  },
  tableWrap: {
    border: "1px solid rgba(226, 232, 240, 1)",
    borderRadius: "18px",
    overflow: "hidden",
    backgroundColor: "#ffffff",
  },
  table: {
    marginBottom: 0,
  },
  tableHeadCell: {
    borderTop: "none",
    fontSize: "12px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    background: "#f8fafc",
    padding: "14px 16px",
    verticalAlign: "top",
  },
  tableHeadSubtext: {
    display: "block",
    fontSize: "10px",
    fontWeight: 700,
    letterSpacing: "0.04em",
    textTransform: "none",
    color: "#94a3b8",
    marginTop: "4px",
  },
  cell: {
    verticalAlign: "top",
    padding: "18px 16px",
    borderTop: "1px solid rgba(226, 232, 240, 0.75)",
    fontSize: "13px",
    color: "#0f172a",
  },
  chip: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "34px",
    padding: "0 12px",
    borderRadius: "999px",
    background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
    color: "#1d4ed8",
    fontSize: "13px",
    fontWeight: 800,
    border: "1px solid rgba(191, 219, 254, 1)",
    whiteSpace: "nowrap",
  },
  periodText: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "8px 12px",
    borderRadius: "14px",
    background: "linear-gradient(135deg, #f8fafc 0%, #eff6ff 100%)",
    border: "1px solid rgba(219, 234, 254, 1)",
    boxShadow: "inset 0 0 0 1px rgba(255, 255, 255, 0.7)",
    fontSize: "14px",
    fontWeight: 700,
    color: "#0f172a",
    marginBottom: "6px",
    cursor: "pointer",
  },
  periodIcon: {
    color: "#2563eb",
    fontSize: "13px",
  },
  metricButton: {
    display: "inline-flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "4px",
    padding: "8px 12px",
    borderRadius: "14px",
    background: "linear-gradient(135deg, #f8fafc 0%, #eff6ff 100%)",
    border: "1px solid rgba(219, 234, 254, 1)",
    boxShadow: "inset 0 0 0 1px rgba(255, 255, 255, 0.7)",
    color: "#0f172a",
    cursor: "pointer",
    textAlign: "left"
  },
  metricPrimary: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
    fontWeight: 800,
    lineHeight: 1.15,
    color: "#0f172a",
  },
  metricSecondary: {
    display: "block",
    color: "#64748b",
    fontSize: "14px",
    fontWeight: 800,
    lineHeight: 1.2,
  },
  metricStack: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  statusStack: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "7px",
  },
  statusPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: "7px",
    minHeight: "30px",
    padding: "6px 11px",
    borderRadius: "999px",
    border: "1px solid transparent",
    fontSize: "12px",
    fontWeight: 700,
    lineHeight: 1.2,
    whiteSpace: "nowrap",
  },
  statusPending: {
    color: "#92400e",
    backgroundColor: "#fffbeb",
    borderColor: "rgba(253, 230, 138, 1)",
  },
  statusApproved: {
    color: "#166534",
    backgroundColor: "#f0fdf4",
    borderColor: "rgba(187, 247, 208, 1)",
  },
  statusRejected: {
    color: "#991b1b",
    backgroundColor: "#fef2f2",
    borderColor: "rgba(254, 202, 202, 1)",
  },
  statusReviewed: {
    color: "#1d4ed8",
    backgroundColor: "#eff6ff",
    borderColor: "rgba(191, 219, 254, 1)",
  },
  statusDate: {
    fontSize: "12px",
    color: "#64748b",
    lineHeight: 1.4,
  },
  docList: {
    listStyle: "none",
    margin: 0,
    padding: 0,
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  docRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "10px",
    padding: "8px 10px",
    border: "1px solid rgba(226, 232, 240, 1)",
    borderRadius: "14px",
    background: "#ffffff",
    boxShadow: "0 6px 14px rgba(15, 23, 42, 0.03)",
  },
  docLink: {
    border: "none",
    background: "transparent",
    color: "#2563eb",
    padding: 0,
    fontSize: "13px",
    fontWeight: 700,
    textAlign: "left",
    wordBreak: "break-word",
  },
  iconButton: {
    width: "30px",
    height: "30px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    boxShadow: "0 6px 14px rgba(15, 23, 42, 0.04)",
  },
  notesButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(191, 219, 254, 1)",
    background: "#eff6ff",
    color: "#1d4ed8",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: 700,
  },
  notesBadge: {
    minWidth: "20px",
    height: "20px",
    borderRadius: "999px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#ffffff",
    color: "#0f172a",
    fontSize: "11px",
    fontWeight: 800,
    padding: "0 6px",
  },
  actionLink: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(191, 219, 254, 1)",
    background: "#eff6ff",
    color: "#1d4ed8",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: 700,
  },
  actionStack: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "8px",
  },
  paymentBlock: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  paymentDate: {
    fontSize: "13px",
    fontWeight: 700,
    color: "#0f172a",
  },
  paymentText: {
    fontSize: "12px",
    color: "#475569",
  },
};

export default function TimeLogs() {
  const usrType = localStorage.getItem("userType");

  const [timeLogInvoices, setTimeLogInvoices] = useState([]);
  const [timeLogs, setTimeLogs] = useState([]);
  const [invType, setInvType] = useState("subcontractor");
  const [entityType, setEntityType] = useState("");
  const [projectStartDate, setProjectStartDate] = useState("");
  const [projectStDt, setProjectStDt] = useState("");
  const [currentStDt, setCurrentStDt] = useState("");
  const [notesType, setNotesType] = useState(
    usrType === "recruiter" ? "TimeLogRecruiter" : "TimeLog"
  );
  const [showHide, setShowHide] = useState(false);
  const [timeLogPopupMode, setTimeLogPopupMode] = useState("calendar");
  const [noteShowHide, setNoteShowHide] = useState(false);
  const [payShowHide, setPayShowHide] = useState(false);
  const [showHideTimeLog, setShowHideTimeLog] = useState(false);
  const [timeLogObj, setTimeLogObj] = useState(null);
  const [candidateObj, setCandidateObj] = useState(null);
  const [appAllTasks, setAllAppTasks] = useState([]);

  const timeLogsSelector = useSelector(getTimeLogs);
  const timeLogInvoiceSelector = useSelector(getTimeLogInvoice);
  const timeLogDurationSelector = useSelector(getTimeLogDuration);
  const updateStatusSelector = useSelector(getProjectDateUpdateStatus);
  const userDetailsSelector = useSelector(getLoggedUserDetails);
  const timeSheetDelStatusSelector = useSelector(getTimeSheetDelStatus);
  const candidateAppAllTasksSelector = useSelector(getCandidateAppAllTasks);

  const [handleDownloadFile] = useDocDownload();

  const currentUser = getCurrentUser();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!userDetailsSelector) {
      dispatch(loadUserDetails(currentUser.id));
    }
  }, []);

  useEffect(() => {
    if (userDetailsSelector) {
      const cnObj = userDetailsSelector;
      const entityType = getFieldData(
        cnObj.performerData,
        "candidateonboardingform",
        "CandidateEntity"
      );
      setCandidateObj(cnObj);
      setEntityType(entityType);
    }
  }, [userDetailsSelector]);

  useEffect(() => {
    setAllAppTasks(candidateAppAllTasksSelector);
  }, [candidateAppAllTasksSelector]);

  useEffect(() => {
    if (currentUser?.id && entityType) {
      dispatch(loadTimeLogs(currentUser.id));
      dispatch(loadTimeLogInvoice(currentUser.id));
      dispatch(loadTimeLogDuration(currentUser.id));
    }
  }, [entityType]);

  useEffect(() => {
    if (timeLogsSelector.length > 0) setTimeLogs(timeLogsSelector);
    if (timeLogInvoiceSelector.length > 0) {
      let invoType = invType;
      if (usrType === "candidate") invoType = usrType;
      if (usrType === "candidate" && entityType === "C2C Basis")
        invoType = "subcontractor";
      const filterInvoices = timeLogInvoiceSelector.filter(
        (x) => x.invoiceType === invoType
      );
      setTimeLogInvoices(filterInvoices);
    }
    if (timeLogDurationSelector?.startDate) {
      const startDate = new Date(timeLogDurationSelector.startDate);
      startDate.setDate(startDate.getDate()); // add 1 day
      const result = startDate.toISOString().substring(0, 10);
      setProjectStDt(startDate);
      setCurrentStDt(timeLogDurationSelector.projectStartedDate);
    }
  }, [timeLogsSelector, timeLogInvoiceSelector, timeLogDurationSelector]);

  useEffect(() => {
    if (updateStatusSelector) {
      getAlert("", "Saved Successfully", "success");
      dispatch(loadTimeLogDuration(currentUser.id));
    }
  }, [updateStatusSelector]);

  const getInvoiceStatus = (item) => {
    const tmLogs = timeLogInvoices.filter(
      (x) => x.timeLogId === item.id && x.status !== null
    );
    if (tmLogs.length === 0) {
      return (
        <span style={{ ...TIME_LOG_STYLES.statusPill, ...TIME_LOG_STYLES.statusPending }}>
          <i className="fa fa-clock-o" aria-hidden="true"></i>
          Review Pending
        </span>
      );
    }

    return (
      <>
        {tmLogs.map((inv, index) => (
          <div key={index} style={TIME_LOG_STYLES.statusStack}>
            <span style={{ ...TIME_LOG_STYLES.statusPill, ...TIME_LOG_STYLES.statusReviewed }}>
              <i className="fa fa-eye" aria-hidden="true"></i>
              Reviewed
            </span>
            {inv.status === true && (
              <span style={{ ...TIME_LOG_STYLES.statusPill, ...TIME_LOG_STYLES.statusApproved }}>
                <i className="fa fa-check" aria-hidden="true"></i>
                Approved
              </span>
            )}
            {inv.status === false && (
              <span style={{ ...TIME_LOG_STYLES.statusPill, ...TIME_LOG_STYLES.statusRejected }}>
                <i className="fa fa-times" aria-hidden="true"></i>
                Rejected
              </span>
            )}
            <span style={TIME_LOG_STYLES.statusDate}>
              <Moment format="MMM Do YYYY">{inv.reviewDateTime}</Moment>
            </span>
          </div>
        ))}
      </>
    );
  };

  const getPaymentStatus = (item) => {
    const tmLogs = timeLogInvoices.filter((x) => x.timeLogId === item.id);

    if (tmLogs.length === 0) return "";
    return (
      <>
        {tmLogs.map((pay, index) => (
          <div key={index} style={TIME_LOG_STYLES.paymentBlock}>
            {pay.paymentMode && (
              <>
                {pay.docList?.map((doc) => (
                  <button
                    key={doc.id}
                    className="btn btn-sm btn-link p-0 text-underline"
                    onClick={() => handleDownloadFile(doc)}
                  >
                    {doc.documentName}
                  </button>
                ))}
                <div style={TIME_LOG_STYLES.paymentDate}>
                  <Moment format="MMM Do YYYY, h:mm a">{pay.paymentDate}</Moment>
                </div>
                {entityType === "W2 Basis" && (
                  <div style={TIME_LOG_STYLES.paymentText}>
                    Deduction:{" "}
                    {pay?.adpDeduction ? (
                      <RateEncryptDecrypt rateData={pay.adpDeduction} />
                    ) : (
                      "$0.00/Hr"
                    )}
                  </div>
                )}
                <div style={TIME_LOG_STYLES.paymentText}>
                  Paid :{" "}
                  {pay?.paidAmount ? (
                    <RateEncryptDecrypt rateData={pay.paidAmount} />
                  ) : (
                    "$0.00/Hr"
                  )}
                </div>
              </>
            )}
          </div>
        ))}
      </>
    );
  };

  const getPerDiemStatus = (item) => {
    const prd = getFieldData(
      candidateObj?.performerData,
      "candidateonboardingform",
      "Per_Diem_Rate"
    );
    return (
      <>
        {/* {prd} */}
        {prd ? <RateEncryptDecrypt rateData={prd} /> : ""}
        <br />
        {/* {prd * getTotalDays(item.workingHrs)} */}
        {prd ? (
          <RateEncryptDecrypt rateData={prd * getTotalDays(item.workingHrs)} endSymbol="" />
        ) : (
          ""
        )}
      </>
    );
  };

  const getTimeLogStatus = (item) => {
    const invoices = timeLogInvoices.filter(
      (x) => x.timeLogId === item.id
    );

    const hasPaidAmount = invoices.some((x) => x.paidAmount > 0);
    const hasApprovedInvoice = invoices.some((x) => x.status === true);

    // No payment recorded yet → editable
    if (!hasPaidAmount) {
      return (
        <div style={TIME_LOG_STYLES.actionStack}>
          <button
            type="button"
            style={TIME_LOG_STYLES.actionLink}
            onClick={() => handleShowHide(item, "calendar")}
          >
            <i className="fa fa-pencil" aria-hidden="true"></i>
            Edit
          </button>
          <button
            type="button"
            style={TIME_LOG_STYLES.actionLink}
            onClick={() => handleShowHide(item, "documents")}
          >
            <i className="fa fa-upload" aria-hidden="true"></i>
            Upload Sheet
          </button>
        </div>
      );
    }

    // Payment exists but not approved → still editable (highlighted)
    if (!hasApprovedInvoice) {
      return (
        <div style={TIME_LOG_STYLES.actionStack}>
          <button
            type="button"
            style={TIME_LOG_STYLES.actionLink}
            onClick={() => handleShowHide(item, "calendar")}
          >
            <i className="fa fa-pencil" aria-hidden="true"></i>
            Edit
          </button>
          <button
            type="button"
            style={TIME_LOG_STYLES.actionLink}
            onClick={() => handleShowHide(item, "documents")}
          >
            <i className="fa fa-upload" aria-hidden="true"></i>
            Upload Sheet
          </button>
        </div>
      );
    }

    // Approved & paid → no action
    return null;
  };


  const getMonthlyPeriod = (obj) => {
    if (!obj?.workingHrs) return "";

    let wt;
    try {
      wt = JSON.parse(obj.workingHrs);
    } catch (e) {
      return "";
    }

    if (!Array.isArray(wt) || wt.length === 0) return "";

    const sortWt = [...wt].sort(
      (a, b) => new Date(a.start) - new Date(b.start)
    );

    const first = sortWt[0];
    const last = sortWt[sortWt.length - 1];

    const lastDate =
      last.type === "m"
        ? getMonthLastDay(last.start)
        : last.start;

    return (
      <div>
        <Moment format="MM/DD/YYYY">{first.start}</Moment>
        {" - "}
        <Moment format="MM/DD/YYYY">{lastDate}</Moment>
      </div>
    );
  };

  const handleNotesComments = (type, obj) => {
    if (type === "save") {
      setTimeLogObj(null);
      setNoteShowHide(false);
    } else {
      setTimeLogObj(obj);
      setNoteShowHide(!noteShowHide);
    }
  };

  const handlePayShowHide = (obj) => {
    setPayShowHide(!payShowHide);
    setTimeLogObj(obj);
  };

  const handleSaveProjectStartDate = () => {
    dispatch(updateProjectStartDate(currentUser.id, projectStartDate));
  };

  const handleStartDate = ({ currentTarget }) => {
    setProjectStartDate(currentTarget.value);
  };

  const handleShowHide = (obj, mode = "calendar") => {
    if (obj === "save") {
      setTimeLogObj("");
      setShowHide(false);
      setTimeLogPopupMode("calendar");
      dispatch(loadTimeLogs(currentUser.id));
    } else {
      setShowHide(obj === null ? false : true);
      setTimeLogObj(obj);
      setTimeLogPopupMode(mode);
    }
  };

  const handleDeleteTimeSheetDoc = async (id) => {
    const result = await getConfirmAlert(
      "Warning",
      "Are you sure you want to delete this Time Sheet?",
      "warning"
    );
    if (result.isConfirmed) {
      dispatch(deleteTimeSheetDoc(id));
    }
  };

  useEffect(() => {
    if (timeSheetDelStatusSelector) {
      getAlert("", "Deleted Successfully", "success");
      dispatch(loadTimeLogs(currentUser.id));
    }
  }, [timeSheetDelStatusSelector]);

  let startDt = projectStartDate;
  if (startDt === "") startDt = new Date();
  let pgTitle = "Time Log Management";
  if (entityType !== "C2C Basis") pgTitle = "Time Log and Payments";
  const totalLoggedHours = timeLogs.reduce(
    (sum, log) => sum + Number(getTotalHours(log?.workingHrs) || 0),
    0
  );
  const totalLoggedDays = timeLogs.reduce(
    (sum, log) => sum + Number(getTotalDays(log?.workingHrs) || 0),
    0
  );
  const reviewedLogs = timeLogs.filter((item) =>
    timeLogInvoices.some((x) => x.timeLogId === item.id && x.status !== null)
  ).length;
  const paidLogs = timeLogs.filter((item) =>
    timeLogInvoices.some((x) => x.timeLogId === item.id && x.paidAmount > 0)
  ).length;

  return (
    <React.Fragment>
      <div className="col-md-12 mt-2">
        {/* <li className="list-group-item p-2 mb-2">
          <p className="text-black">
            Enter your daily hours logged for each week and upload the
            completed /signed time sheets. Once you enter the hours and upload
            the time sheet all entities as applicable (except the Agency at
            which you are working) will see it in real-time, and this includes
            your employers/subcontractors, if any.
          </p>
          <p className="text-black mt-2">
            Please ensure to log hours and upload time sheets on time to avoid
            any delays in raising invoices to the Agencies.
          </p>
        </li> */}
        <div className="card shadow-none border" style={TIME_LOG_STYLES.card}>
          <div className="card-header" style={TIME_LOG_STYLES.cardHeader}>
            <div style={TIME_LOG_STYLES.titleRow}>
              <div style={TIME_LOG_STYLES.titleWrap}>
                <span style={TIME_LOG_STYLES.titleIcon}>
                  <i className="fa fa-clock-o" aria-hidden="true"></i>
                </span>
                <div>
                  <div style={TIME_LOG_STYLES.title}>{pgTitle}</div>
                  <p style={TIME_LOG_STYLES.subtitle}>
                    Track submitted time, supporting timesheets, review status, and payments in one place.
                  </p>
                </div>
              </div>
              <div>
                <button
                  className="btn btn-sm"
                  style={TIME_LOG_STYLES.primaryButton}
                  disabled={
                    appAllTasks.filter((x) => x.loanPhase_Desc === "Time Log")
                      .length === 0
                  }
                  onClick={() => handleShowHide("", "calendar")}
                >
                  <i className="fa fa-plus" aria-hidden="true"></i> Add Time Log
                </button>
              </div>
            </div>
          </div>
          <div className="card-body" style={TIME_LOG_STYLES.cardBody}>
            <div style={TIME_LOG_STYLES.statsRow}>
              <div style={TIME_LOG_STYLES.statCard}>
                <div style={TIME_LOG_STYLES.statLabel}>Time Logs</div>
                <div style={TIME_LOG_STYLES.statValue}>{timeLogs.length}</div>
                <div style={TIME_LOG_STYLES.statHint}>Submitted time log periods currently available.</div>
              </div>
              <div style={TIME_LOG_STYLES.statCard}>
                <div style={TIME_LOG_STYLES.statLabel}>Total Hours</div>
                <div style={TIME_LOG_STYLES.statValue}>{formatTotalHours(totalLoggedHours)}</div>
                <div style={TIME_LOG_STYLES.statHint}>Combined hours logged across all visible periods.</div>
              </div>
              <div style={TIME_LOG_STYLES.statCard}>
                <div style={TIME_LOG_STYLES.statLabel}>Total Days</div>
                <div style={TIME_LOG_STYLES.statValue}>{totalLoggedDays}</div>
                <div style={TIME_LOG_STYLES.statHint}>Working days recorded from submitted time logs.</div>
              </div>
              <div style={TIME_LOG_STYLES.statCard}>
                <div style={TIME_LOG_STYLES.statLabel}>Reviewed / Paid</div>
                <div style={TIME_LOG_STYLES.statValue}>{reviewedLogs} / {paidLogs}</div>
                <div style={TIME_LOG_STYLES.statHint}>Periods reviewed by IPCS and periods with payment activity.</div>
              </div>
            </div>
            <div style={TIME_LOG_STYLES.utilityRow}>
              <div style={TIME_LOG_STYLES.utilityPanel}>
                <div style={TIME_LOG_STYLES.utilityPanelTop}>
                  <span style={TIME_LOG_STYLES.utilityIcon}>
                    <i className="fa fa-calendar" aria-hidden="true"></i>
                  </span>
                  <div style={TIME_LOG_STYLES.utilityCopy}>
                    <div style={TIME_LOG_STYLES.utilityLabel}>Date Started On The Project</div>
                    <div style={TIME_LOG_STYLES.utilityValue}>
                      {projectStDt !== ""
                        ? new Date(projectStDt).toISOString().substring(0, 10)
                        : new Date(startDt).toISOString().substring(0, 10)}
                    </div>
                  </div>
                </div>
                {projectStDt !== "" ? (
                  <div style={TIME_LOG_STYLES.utilityActions}>
                    <button
                      className="btn btn-sm btn-outline-default"
                      style={TIME_LOG_STYLES.utilityButton}
                      disabled={
                        appAllTasks.filter((x) => x.loanPhase_Desc === "Time Log")
                          .length === 0
                      }
                      onClick={() => setProjectStDt("")}
                    >
                      <i className="fa fa-edit" aria-hidden="true"></i> Edit
                    </button>
                  </div>
                ) : (
                  <div style={TIME_LOG_STYLES.utilityEditor}>
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      style={TIME_LOG_STYLES.utilityInput}
                      value={new Date(startDt).toISOString().substring(0, 10)}
                      onChange={handleStartDate}
                    />
                    <button
                      className="btn btn-sm btn-outline-default mr-0"
                      style={{ ...TIME_LOG_STYLES.utilityButton, ...TIME_LOG_STYLES.utilityPrimaryButton }}
                      onClick={handleSaveProjectStartDate}
                    >
                      <i className="fa fa-check" aria-hidden="true"></i> Save
                    </button>
                    <button
                      className="btn btn-sm btn-outline-default"
                      style={{ ...TIME_LOG_STYLES.utilityButton, ...TIME_LOG_STYLES.utilityDangerButton }}
                      onClick={() => setProjectStDt(currentStDt)}
                    >
                      <i className="fa fa-times" aria-hidden="true"></i> Cancel
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div className="table-responsive" style={TIME_LOG_STYLES.tableWrap}>
              <table className="table table-hover align-items-center" style={TIME_LOG_STYLES.table}>
                <thead>
                  <tr>
                    <th style={TIME_LOG_STYLES.tableHeadCell}>Year</th>
                    <th style={TIME_LOG_STYLES.tableHeadCell}>Month</th>
                    <th style={TIME_LOG_STYLES.tableHeadCell}>
                      Period
                      <span style={TIME_LOG_STYLES.tableHeadSubtext}>Time Logged</span>
                    </th>
                    <th style={TIME_LOG_STYLES.tableHeadCell}>
                      Total Hours
                      <span style={TIME_LOG_STYLES.tableHeadSubtext}>Total Days</span>
                    </th>
                    <th style={TIME_LOG_STYLES.tableHeadCell}>
                      Approved
                      <span style={TIME_LOG_STYLES.tableHeadSubtext}>Timesheets</span>
                    </th>

                    {entityType !== "W2 Basis" && <th style={TIME_LOG_STYLES.tableHeadCell}>Status</th>}

                    <th style={TIME_LOG_STYLES.tableHeadCell}>
                      Notes
                      <span style={TIME_LOG_STYLES.tableHeadSubtext}>from IPCS</span>
                    </th>

                    {(entityType === "W2 Basis" || entityType !== "C2C Basis") && (
                      <th style={TIME_LOG_STYLES.tableHeadCell}>
                        Payment Date & Time
                        {entityType === "W2 Basis" && <span style={TIME_LOG_STYLES.tableHeadSubtext}>Deduction ($)</span>}
                        <span style={TIME_LOG_STYLES.tableHeadSubtext}>Payment ($)</span>
                      </th>
                    )}

                    {entityType === "W2 Basis" && (
                      <th style={TIME_LOG_STYLES.tableHeadCell}>
                        Per Diem Rate
                        <span style={TIME_LOG_STYLES.tableHeadSubtext}>Amount ($)</span>
                      </th>
                    )}

                    <th style={TIME_LOG_STYLES.tableHeadCell}>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {timeLogs.map((item) => (
                    <tr key={item.id}>
                      <td style={TIME_LOG_STYLES.cell}>
                        <span>{item.year}</span>
                      </td>
                      <td style={TIME_LOG_STYLES.cell}>
                        <span>{getMonthName(item.month)}</span>
                      </td>

                      <td style={TIME_LOG_STYLES.cell}>
                        <button
                          type="button"
                          style={TIME_LOG_STYLES.periodText}
                          onClick={() => handleShowHide(item, "calendar")}
                        >
                          <i className="fa fa-calendar-o" aria-hidden="true" style={TIME_LOG_STYLES.periodIcon}></i>
                          <span>{getMonthlyPeriod(item)}</span>
                        </button>
                      </td>

                      <td style={TIME_LOG_STYLES.cell}>
                        <button
                          type="button"
                          style={TIME_LOG_STYLES.metricButton}
                          onClick={() => handleShowHide(item, "calendar")}
                        >
                          <span style={TIME_LOG_STYLES.metricPrimary}>
                            <i className="fa fa-clock-o" aria-hidden="true"></i>
                            {formatTotalHours(item?.workingHrs)}
                          </span>
                          <span style={TIME_LOG_STYLES.metricSecondary}>
                            {getTotalDays(item.workingHrs)}{" "}
                            {getTotalDays(item.workingHrs) > 1 ? "Days" : "Day"}
                          </span>
                        </button>
                      </td>

                      {/* Approved Timesheets */}
                      <td style={TIME_LOG_STYLES.cell}>
                        <ul style={TIME_LOG_STYLES.docList}>
                          {item.docList?.map((doc) => {
                            const isLocked = timeLogInvoices.some(
                              (x) => x.timeLogId === item.id && x.status === true
                            );

                            return (
                              <li key={doc.id} style={TIME_LOG_STYLES.docRow}>
                                <button
                                  type="button"
                                  style={TIME_LOG_STYLES.docLink}
                                  onClick={() => handleDownloadFile(doc)}
                                >
                                  {doc.documentName}
                                </button>

                                <button
                                  type="button"
                                  style={TIME_LOG_STYLES.iconButton}
                                  title="Delete Timesheet"
                                  disabled={isLocked}
                                  onClick={() => handleDeleteTimeSheetDoc(doc.id)}
                                >
                                  <i className="fa fa-trash text-dark" />
                                </button>
                              </li>
                            );
                          })}
                        </ul>
                      </td>

                      {entityType !== "W2 Basis" && (
                        <td style={TIME_LOG_STYLES.cell}>{getInvoiceStatus(item)}</td>
                      )}

                      {/* Notes */}
                      <td style={TIME_LOG_STYLES.cell}>
                        <button
                          type="button"
                          style={TIME_LOG_STYLES.notesButton}
                          onClick={() => handleNotesComments("", item)}
                        >
                          <i className="fa fa-commenting-o" aria-hidden="true"></i>
                          View
                          <span style={TIME_LOG_STYLES.notesBadge}>
                            {
                              item?.allComments?.filter(
                                (x) => x.commentType === notesType
                              ).length
                            }
                          </span>
                        </button>
                      </td>

                      {entityType !== "C2C Basis" && (
                        <td style={TIME_LOG_STYLES.cell}>{getPaymentStatus(item)}</td>
                      )}

                      {entityType === "W2 Basis" && (
                        <td style={TIME_LOG_STYLES.cell}>{getPerDiemStatus(item)}</td>
                      )}

                      <td style={TIME_LOG_STYLES.cell}>{getTimeLogStatus(item)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

            </div>
          </div>
        </div>
      </div>

      <AddNewTimeLog
        showHide={showHide}
        handleShowHide={handleShowHide}
        selectedObj={timeLogObj}
        popupMode={timeLogPopupMode}
        timeLogInvoices={timeLogInvoices}
        allTimeLogs={timeLogsSelector}
        candidateObj={candidateObj}
        projectStartDate={projectStDt}
      ></AddNewTimeLog>

      <AddEditNotes
        noteShowHide={noteShowHide}
        handleNoteShowHide={handleNotesComments}
        notesType={notesType}
        candidateObj={candidateObj}
        timeLogObj={timeLogObj}
      ></AddEditNotes>

      <CandidatePay
        payShowHide={payShowHide}
        handlePayShowHide={handlePayShowHide}
        selectedObj={timeLogObj}
        candidateObj={candidateObj}
      ></CandidatePay>

      {/* <AddTimeLog
        showHideTimeLog={showHideTimeLog}
        handleShowHideTimeLog={handleShowHideTimeLog}
        appTasklist={appTasklist}
        workflowTask={workflowTask}
      ></AddTimeLog> */}
    </React.Fragment>
  );
}
